// SavingsPotsEntity.js
export class SavingsPotDetailsEntity {
  constructor() {
    this.id = null;
    this.name = null;
    this.goalAmount = null;
    this.goalAmountCurrency = null;
    this.goalWhen = null;
    this.reference = null;
    this.interval = null;
    this.dayOfMonth = null;
    this.monthlyContry = null;
    this.monthlyContryCurrency = null;
    this.balance = null;
  }
}
export default SavingsPotDetailsEntity;
